import { ChartAssetsBreakdown } from '@/modules/issuer-dashboard/components/portfolios/ChartAssetsBreakdown.tsx';
import { ChartPnlOverTime } from '@/modules/issuer-dashboard/components/portfolios/ChartPnlOverTime.tsx';
import { ChartTotalCashInAndOut } from '@/modules/issuer-dashboard/components/portfolios/ChartTotalCashInAndOut.tsx';
import { ChartTreemapAsset } from '@/modules/issuer-dashboard/components/portfolios/ChartTreemapAsset.tsx';
import { BlockPortfolioOverviewStatistics } from '@/modules/issuer-dashboard/components/portfolios/PortfolioOverviewStatistics.tsx';
import { PortfolioExtended } from 'api';

interface PortfolioOverviewTabProps {
  portfolio: PortfolioExtended;
}
export const PortfolioOverviewTab = ({ portfolio }: PortfolioOverviewTabProps) => {
  return (
    <div className="flex flex-col gap-6 w-full px-6 pt-4">
      <BlockPortfolioOverviewStatistics item={portfolio} />
      <ChartTreemapAsset portfolioId={portfolio.id} />
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
        <ChartAssetsBreakdown portfolioId={portfolio.id} />
        <ChartTotalCashInAndOut portfolioId={portfolio.id} />
      </div>
      {/* <div className="grid grid-cols-1 xl:grid-cols-2 gap-6"> */}
      <div className="w-full">
        <ChartPnlOverTime portfolioId={portfolio.id} />
        {/* <ChartValueOverTime portfolioId={portfolio.id} /> */}
      </div>
    </div>
  );
};
